module.exports = __webpack_public_path__ + "static/media/vertex_exploded_GreatIcosahedron_centered_at_vertex.9c0b13f9.gif";